export default __webpack_public_path__ + "static/media/map-test.0bd29bb3.jpeg";